document.addEventListener("DOMContentLoaded", () => {
  const discountWrapper = document.querySelector("[data-quantity-discount]");
  if (!discountWrapper) return;

  const discountQtyInput = document.querySelector(".volume-discount-quantity");
  if (!discountQtyInput) return;

  const radios = discountWrapper.querySelectorAll(
    'input[type="radio"][data-qty]'
  );
  if (!radios.length) return;

  function applyQtyFromRadio(radio) {
    const qty = parseInt(radio.dataset.qty, 10);
    if (!qty || qty < 1) return;

    discountQtyInput.value = qty;
    discountQtyInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  radios.forEach((radio) => {
    radio.addEventListener("change", () => {
      if (!radio.checked) return;
      applyQtyFromRadio(radio);
    });
  });

  const checkedRadio =
    discountWrapper.querySelector('input[type="radio"][data-qty]:checked') ||
    radios[0];

  if (checkedRadio) {
    checkedRadio.checked = true;
    applyQtyFromRadio(checkedRadio);
  }
});
